import { render, staticRenderFns } from "./StudentDataLayout.vue?vue&type=template&id=5250a10a&scoped=true"
import script from "./StudentDataLayout.vue?vue&type=script&lang=js"
export * from "./StudentDataLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5250a10a",
  null
  
)

export default component.exports